import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './AppBarBottom.css';
import { useAppStoreHome } from '../context/AppStoreHomeContext';
import { appsAPI } from '../api/appsAPI';

function AppBarBottom({
  minimizedBubbles = [],
  onRestoreBubble,
  onCloseBubble,
  onToggleChat,
  isChatOpen,
  isChatFullView = false,
  autoHide = false,
  onHomeClick,
  apps = [],
}) {
  const navigate = useNavigate();

  const homeCtx = useAppStoreHome();

  const activeBubbles = minimizedBubbles.length > 0
    ? minimizedBubbles
    : (homeCtx?.allBubbles || []).filter((b) => !b.hidden && b.minimized);

  const restoreHandler = onRestoreBubble || homeCtx?.restoreBubble;
  const closeHandler = onCloseBubble || homeCtx?.deleteBubble;

  const [internalApps, setInternalApps] = useState([]);

  useEffect(() => {
    if (apps && apps.length > 0) {
      setInternalApps(apps);
      return;
    }
    let active = true;
    appsAPI.getAppsForUser()
      .then((res) => {
        if (!active) return;
        const list = Array.isArray(res) ? res : (res?.apps || []);
        setInternalApps(list);
      })
      .catch(() => {
        appsAPI.getApps()
          .then((res) => {
            if (!active) return;
            setInternalApps(Array.isArray(res) ? res : []);
          })
          .catch(() => {});
      });
    return () => {
      active = false;
    };
  }, [apps]);

  const [isPinned, setIsPinned] = useState(true);

  const handlePinToggle = () => {
    setIsPinned(!isPinned);
  };

  const getAppForBubble = (bubble) => {
    const appId = bubble.data?.appId || (bubble.link && bubble.link.match(/\/apps-store\/([^/]+)/)?.[1]);
    return appId ? (internalApps || []).find((a) => a.id === appId) : null;
  };



  // Commented out globally to replace with FloatingRightMenu
  return null;

  return (
    <div className={`app-bar-bottom-wrapper${(autoHide || !isPinned) ? ' app-bar-bottom-wrapper-auto-hide' : ''}`}>
      {(autoHide || !isPinned) && <div className="app-bar-bottom-hover-trigger" aria-hidden="true" />}
      <footer className={`app-bar-bottom${(autoHide || !isPinned) ? ' app-bar-bottom-transparent' : ''}`}>
        <div className="app-bar-bottom-inner">
          <div className="app-bar-bottom-dock-container">
            {/* Main lavender pill dock */}
            <div className="app-bar-bottom-dock">
              {/* 1. Chat */}
              <button
                type="button"
                className={`app-bar-bottom-icon app-bar-bottom-icon-chat${
                  isChatOpen ? ' app-bar-bottom-icon-active' : ''
                }`}
                onClick={() => {
                  navigate('/chat');
                }}
                title="Chat"
                aria-label="Chat"
              >
                <span className="app-bar-bottom-icon-inner">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 5a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2h-5.5L8 19.5V15H6a2 2 0 01-2-2V5z"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>

              {/* 2. Notes (placeholder) */}
              <button
                type="button"
                className="app-bar-bottom-icon app-bar-bottom-icon-productivity"
                onClick={() => navigate('/notes')}
                title="Notes"
                aria-label="Notes"
              >
                <span className="app-bar-bottom-icon-inner">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" />
                    <path d="M14 2V8H20" />
                    <path d="M16 13H8" />
                    <path d="M16 17H8" />
                  </svg>
                </span>
              </button>

              {/* 3. Apps */}
              <button
                type="button"
                className="app-bar-bottom-icon app-bar-bottom-icon-store"
                onClick={() => navigate('/apps')}
                title="Apps"
                aria-label="Apps"
              >
                <span className="app-bar-bottom-icon-inner">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 7L7 20H17L18 7H6Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9 10V6C9 4.34315 10.3431 3 12 3V3C13.6569 3 15 4.34315 15 6V10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>

              {/* 4. Cases */}
              <button
                type="button"
                className="app-bar-bottom-icon app-bar-bottom-icon-experience"
                onClick={() => navigate('/cases')}
                title="Cases"
                aria-label="Cases"
              >
                <span className="app-bar-bottom-icon-inner">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>

              {/* 5. Create
              <button
                type="button"
                className="app-bar-bottom-icon app-bar-bottom-icon-studio"
                onClick={() => navigate('/studio')}
                title="Create"
                aria-label="Create"
              >
                <span className="app-bar-bottom-icon-inner">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10 9L15 12L10 15V9Z" fill="currentColor" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>
              */}

              {/* Pin Button */}
              <button
                type="button"
                className={`app-bar-bottom-icon app-bar-bottom-icon-pin${isPinned ? ' app-bar-bottom-icon-active' : ''}`}
                onClick={handlePinToggle}
                title={isPinned ? "Unstick Menu (Auto-hide)" : "Stick Menu (Always Visible)"}
                aria-label={isPinned ? "Unstick Menu" : "Stick Menu"}
              >
                <span className="app-bar-bottom-icon-inner">
                  <svg 
                    width="14" 
                    height="14" 
                    viewBox="0 0 24 24" 
                    fill={isPinned ? "currentColor" : "none"} 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    style={{ 
                      transform: isPinned ? 'rotate(0deg)' : 'rotate(-45deg)', 
                      transition: 'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), fill 0.2s ease' 
                    }}
                  >
                    <path d="M12 17v5M9 10.76a2 2 0 0 1-1.11 1.79L4 14.5v1.5h16v-1.5l-3.89-1.95A2 2 0 0 1 15 10.76V5h-6zM15 5V3H9v2" />
                  </svg>
                </span>
              </button>
            </div>

          </div>

          {activeBubbles.length > 0 && (
            <div className="app-bar-bottom-minimized">
              {activeBubbles.map((bubble) => {
                const app = getAppForBubble(bubble);
                const imageUrl = app?.images?.small || app?.images?.medium || app?.images?.large;
                const isTutorialNoImage = app?.app_type === 'tutorial' && !imageUrl;
                const label = bubble.title || app?.title || 'App';
                return (
                  <div
                    key={bubble.id}
                    className="app-bar-bottom-minimized-item"
                    title={label}
                  >
                    <button
                      type="button"
                      className="app-bar-bottom-minimized-icon-btn"
                      onClick={() => restoreHandler && restoreHandler(bubble.id)}
                      aria-label={label}
                    >
                      <span className="app-bar-bottom-icon-inner">
                        {imageUrl ? (
                          <img src={imageUrl} alt="" />
                        ) : isTutorialNoImage ? (
                          <span className="app-bar-bottom-quiz-label">
                            {(app?.exam_name || app?.title || label).slice(0, 3).toUpperCase()}
                          </span>
                        ) : (
                          <img src="/logo192.png" alt="" />
                        )}
                      </span>
                    </button>
                    <button
                      type="button"
                      className="app-bar-bottom-minimized-close"
                      aria-label="Close"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (closeHandler) closeHandler(bubble.id);
                      }}
                    >
                      ×
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </footer>
    </div>
  );
}

export default AppBarBottom;
